import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, Medal, Shirt, Check, Lock } from 'lucide-react';
interface RewardProgressProps {
  referrals: number;
}
const milestones = [{
  count: 3,
  label: 'Free Coffee',
  icon: Coffee,
  rowBg: 'bg-orange-100',
  nodeBg: 'bg-orange-400'
}, {
  count: 10,
  label: 'Founding Member',
  icon: Medal,
  rowBg: 'bg-violet-100',
  nodeBg: 'bg-violet-500'
}, {
  count: 25,
  label: 'VIP Merch',
  icon: Shirt,
  rowBg: 'bg-pink-100',
  nodeBg: 'bg-pink-500'
}];
export function RewardProgress({
  referrals
}: RewardProgressProps) {
  return <div className="w-full mt-6 text-left" data-id="element-72">
      <h3 className="font-bold text-sm uppercase tracking-wider mb-1" data-id="element-73">
        Unlock rewards
      </h3>
      <p className="text-sm text-gray-600 font-medium mb-5" data-id="element-74">
        When friends sign up with your invite code, you unlock these perks — and
        climb the line.
      </p>

      <div className="relative pl-2" data-id="element-75">
        {/* Connecting track behind the nodes */}
        <div className="absolute left-[1.625rem] top-7 bottom-7 w-1 bg-black/15 rounded-full" aria-hidden="true" data-id="element-76" />

        <ol className="space-y-4" data-id="element-77">
          {milestones.map((milestone, i) => {
          const isUnlocked = referrals >= milestone.count;
          const Icon = milestone.icon;
          return <motion.li key={milestone.count} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.1 * i,
            duration: 0.4
          }} className="relative flex items-center gap-4" data-id="element-78">
                {/* Timeline node */}
                <div className={`relative z-10 w-12 h-12 flex-shrink-0 rounded-full border-4 border-black flex items-center justify-center text-white neo-shadow ${milestone.nodeBg}`} data-id="element-79">
                  <Icon className="w-5 h-5" aria-hidden="true" data-id="element-80" />
                </div>

                {/* Perk row */}
                <div className={`flex-grow flex items-center gap-3 px-4 py-3 rounded-2xl border-4 border-black ${milestone.rowBg}`} data-id="element-81">
                  <div className="flex-grow" data-id="element-82">
                    <p className="font-bold text-base leading-tight" data-id="element-83">
                      {milestone.label}
                    </p>
                    <p className="text-xs font-bold uppercase tracking-wide opacity-70" data-id="element-84">
                      {milestone.count} friends sign up
                    </p>
                  </div>

                  <div className={`w-8 h-8 flex-shrink-0 rounded-full border-2 border-black flex items-center justify-center ${isUnlocked ? 'bg-black text-white' : 'bg-white text-black/40'}`} aria-label={isUnlocked ? 'Unlocked' : 'Locked'} data-id="element-85">
                    {isUnlocked ? <Check className="w-4 h-4" data-id="element-86" /> : <Lock className="w-4 h-4" data-id="element-87" />}
                  </div>
                </div>
              </motion.li>;
        })}
        </ol>
      </div>
    </div>;
}